<section class="producto" title="{{ newProducto.nombre }}" (click)="fnInformacionProducto()">
	<figure>
		<div>
			<img *ngIf=" newProducto.fotografia.length > 0 " [src]=" fnGetImage() " alt="{{ newProducto.nombre }}" loading="lazy"/>
			<img *ngIf=" newProducto.fotografia.length === 0 " src=" assets/images/sinFotografia.png" alt="{{ newProducto.nombre }}" loading="lazy"/>
		</div>
	</figure>
	<figcaption>
		<div>
			<p class="color-purple">
				{{ newProducto.nombre }}
			</p>	
		</div>
		<div>
			<p class="color-blue">
				<span class="color-blue" *ngIf=" !newProducto.hasDescuento ">
					{{ newProducto.precio | currency:newProducto.divisa:'symbol':'.2-2' }}
				</span>
				<span class="producto-descuento" *ngIf=" newProducto.hasDescuento ">
					<span class="color-blue">
						{{ (newProducto.precio - newProducto.descuento) | currency:newProducto.divisa:'symbol':'.2-2' }}
					</span>
					<span>
						{{ newProducto.precio | currency:newProducto.divisa:'symbol':'.2-2' }}
					</span>
				</span>
			</p>
		</div>
		<div [innerHTML]=" newProducto.descripcion "></div>
	</figcaption>
</section>